import { getSwsSdk } from './sws'
import { App } from 'vue'

const swsplugin = {
  install: (app: App): void => {
    app.provide('$swsSdk', getSwsSdk())
  }
}

export {
  swsplugin
}